<div *ngIf="formGroup && formGroup.get(controlName)"
  [ngClass]="['field', removeVerticalSpacing ? 'remove-vertical-space' : '', labelPosition == 'left' ? 'horizontal' : '']"
  [formGroup]="formGroup">
  <label class="field__title" [for]="id"
         [ngClass]="{'field__title--left': labelPosition == 'left'}">{{label ? label : ""}}</label>

  <input [id]="id" [placeholder]="placeholder ? placeholder : ''" [formControlName]="controlName"
         [readonly]="readonly" [dropSpecialCharacters]="dropSpecialCharacters" [disabled]="disabled"
         [mask]="maskOptions != undefined && maskOptions.mask != undefined ? maskOptions.mask : ''"
         [ngClass]="[(formGroup.get(controlName)!.errors && formGroup.get(controlName)!.touched) || (formGroup.get(controlName)!.errors && formGroup.get(controlName)!.errors['response']) ? 'error' : '', capitalize ? 'capitalize' : '']"
         (keypress)="checkKey($event)" (focusout)="focusOutHandle($event)" [type]="type" [max]="max" [min]="min"/>
  <app-form-error [id]="id" [formGroup]="formGroup" *ngIf="showError" [controlName]="controlName"></app-form-error>
</div>
